const MULTI_VALUED_INPUTS = ['sliderRange','fieldRange','checkboxes']

export default {
  model:{
    prop: 'value',
    event: 'change'
  },
  props: {
    view: Object,
    valueType: String,
    name: {},
    value: {
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    valueOptions: {
      type: Array
    }
  },
  computed:{
    
    //Chapuzilla de los "MULTI_VALUED_INPUTS"... acabar de ver si funciona...!
    internalValue: {
      get: function () {
        if(this.view.isFrontend) return this.value
        else
          if(MULTI_VALUED_INPUTS.indexOf(this.view.inputType)>=0 || (this.view.inputType == 'select' && this.view.validate_max >1)) return this.value
          else return this.value && this.value[0] 
      },
      set: function (val) { 
        if(this.view.isFrontend) this.$emit('change',val)
        else
          if(MULTI_VALUED_INPUTS.indexOf(this.view.inputType)>=0 || (this.view.inputType == 'select' && this.view.validate_max >1)) this.$emit('change',val)
          else this.$emit('change',[val])
      }
    },
    minVal () {
      return this.view.validate_min && this.view.validate_min[0]
    },
    maxVal () {
      return this.view.validate_max && this.view.validate_max[this.view.validate_max.length-1]
    },
    step () {
      // con el "valueType" fuera del view estamos un poco jodidos...
      if (this.valueType === 'integer') {
        return 1
      } else if (this.valueType === 'decimal1' || this.valueType === 'decimal') {
        return 0.1
      } else if (this.valueType === 'decimal2') {
        return 0.01
      } else if (this.valueType === 'real') {
        return 0.01
      } else {
        return 0.001
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
  }
}